// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Provider Location Model
*/
export class ClaimProviderLocationModel {
    /**
    * @description ID of Provider Location belongs to
    */
    'providerId'?: number;
    /**
    * @description Provider Location Purpose Type ID
    */
    'locationPurposeTypeId'?: number;
    /**
    * @description Address 1
    */
    'address1'?: string | null;
    /**
    * @description Address 2
    */
    'address2'?: string | null;
    /**
    * @description City
    */
    'city'?: string | null;
    /**
    * @description State
    */
    'state'?: string | null;
    /**
    * @description Country
    */
    'country'?: string | null;
    /**
    * @description ZIP Code
    */
    'zipCode'?: string | null;
    /**
    * @description ZIP Code 4 digit extension
    */
    'zipCode4'?: string | null;
    /**
    * @description Phone Number
    */
    'phoneNumber'?: string | null;
    /**
    * @description FAX Number
    */
    'faxNumber'?: string | null;
    /**
    * @description Email Address
    */
    'emailAddress'?: string | null;
    /**
    * @description Provider Location ID
    */
    'providerLocationId'?: number;
    /**
    * @description Provider Location Purpose Type Code
    */
    'locationPurposeTypeCode'?: string | null;
    /**
    * @description Provider Location Purpose Type Description
    */
    'locationPurposeTypeDescription'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimProviderLocationModel>> = [
        {
            "name":     "providerId",
            "baseName": "providerId",
            "type":     "number"
        },
        {
            "name":     "locationPurposeTypeId",
            "baseName": "locationPurposeTypeId",
            "type":     "number"
        },
        {
            "name":     "address1",
            "baseName": "address1",
            "type":     "string"
        },
        {
            "name":     "address2",
            "baseName": "address2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "country",
            "baseName": "country",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
        {
            "name":     "zipCode4",
            "baseName": "zipCode4",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "faxNumber",
            "baseName": "faxNumber",
            "type":     "string"
        },
        {
            "name":     "emailAddress",
            "baseName": "emailAddress",
            "type":     "string"
        },
        {
            "name":     "providerLocationId",
            "baseName": "providerLocationId",
            "type":     "number"
        },
        {
            "name":     "locationPurposeTypeCode",
            "baseName": "locationPurposeTypeCode",
            "type":     "string"
        },
        {
            "name":     "locationPurposeTypeDescription",
            "baseName": "locationPurposeTypeDescription",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimProviderLocationModel.attributeTypeMap;
    }
}
